/**
 * Copy for the Element conversation-entry chooser (PB-12).
 *
 * `POST /ARIS/v4/discovery/elements/{name}/talk` returns i18n *keys*
 * (`question_key`, `label_key`, `hint_key`) and no locale bundle exists in
 * either service — the same known gap Journey and Explore live with. The
 * strings below are transcribed verbatim from the spec that defines the
 * screen: Aris_Foundational Self-Knowledge_Elements Discovery_v26.1,
 * "Conversation Entry":
 *
 *     How would you like to continue?
 *     Talk with Aris / Voice conversation / Recommended for reflection.
 *     Chat with Aris / Text conversation / Great when speaking isn't convenient.
 *
 * Nothing here is invented; an unknown key falls back to its own name rather
 * than to a plausible-sounding sentence.
 */
const COPY = {
  "element.talk.how_would_you_like_to_continue": "How would you like to continue?",
  "mode.talk_with_aris": "Talk with Aris",
  "mode.voice.hint": "Recommended for reflection.",
  "mode.chat_with_aris": "Chat with Aris",
  "mode.text.hint": "Great when speaking isn't convenient.",
};

/** Resolve a key served by the endpoint, falling back to the key itself. */
export const tk = (key, fallback) => {
  if (!key) return fallback || "";
  return COPY[key] || fallback || key;
};

/**
 * The middle line of each option ("Voice conversation" / "Text conversation").
 * The spec shows it; the endpoint sends no key for it, so it is keyed here by
 * the `mode` value the endpoint does send.
 */
export const MODE_DESCRIPTION = {
  VOICE: "Voice conversation",
  TEXT: "Text conversation",
};
